import { Box } from '@mui/material';
import AppsIcon from '@mui/icons-material/Apps';
import LayersClearIcon from '@mui/icons-material/LayersClear';
import { useTranslation } from 'react-i18next';
import CardGrid from '../../../components/cards/layout/CardGrid';
import { CategoryGridItem } from './CategoryGridItem';
import { CategoryListItem } from './CategoryListItem';

const VIRTUAL_COLOR = '#9e9e9e';

export const ProjectCategoriesView = ({
  categories,
  viewMode,
  onSelect,
  onSelectAll,
  onSelectUncategorized,
  topContent = null,
}) => {
  const { t } = useTranslation();

  const virtualItems = [
    {
      _key: 'all',
      label: t('All'),
      color: VIRTUAL_COLOR,
      VirtualIcon: AppsIcon,
      onClick: onSelectAll,
    },
    {
      _key: 'uncategorized',
      label: t('Uncategorized'),
      color: VIRTUAL_COLOR,
      VirtualIcon: LayersClearIcon,
      onClick: onSelectUncategorized,
    },
  ];

  const realItems = categories?.data || [];

  return (
    <Box className="h-full overflow-y-auto pb-4 flex flex-col gap-2">
      {topContent}
      {viewMode === 'list' ? (
        <Box className="flex flex-col gap-2">
          {virtualItems.map((v) => (
            <CategoryListItem
              key={v._key}
              category={v}
              onClick={v.onClick}
            />
          ))}
          {realItems.map((cat) => (
            <CategoryListItem
              key={cat.id}
              category={cat}
              onClick={onSelect}
            />
          ))}
        </Box>
      ) : (
        <CardGrid>
          {virtualItems.map((v) => (
            <CategoryGridItem
              key={v._key}
              category={v}
              onClick={v.onClick}
            />
          ))}
          {realItems.map((cat) => (
            <CategoryGridItem
              key={cat.id}
              category={cat}
              onClick={onSelect}
            />
          ))}
        </CardGrid>
      )}
    </Box>
  );
};
